import { IFormErrors } from '@interfaces/IFormsErrors';
import {
  IAddCheckingTeacherData,
  IGroup,
  IRefreshCheckingTeacherHomeworks,
} from '@interfaces/IGroup';
import { IHappyPointMutation } from '@interfaces/IHappyPoint';
import { IGroupFormErrors } from '@myStore/groups/groups.state';
import { Action } from '@ngrx/store';

export enum EGroupsChangesActions {
  SendCreateGroupRequest = '[Groups] Send Create Group Request',
  SendCreateGroupSuccess = '[Groups] Send Create Group Success',
  SendCreateGroupFailure = '[Groups] Send Create Group Failure',
  ClearCreateGroupErrors = '[Groups] Clear Create Group Errors',

  SendUpdateGroupRequest = '[Groups] Send Update Group Request',
  SendUpdateGroupSuccess = '[Groups] Send Update Group Success',
  SendUpdateGroupFailure = '[Groups] Send Update Group Failure',
  ClearUpdateGroupErrors = '[Groups] Clear Update Group Errors',

  DeleteGroupRequest = '[Groups] Delete Group Request',
  DeleteGroupSuccess = '[Groups] Delete Group Success',
  DeleteGroupFailure = '[Groups] Delete Group Failure',
  ClearDeleteGroupErrors = '[Groups] Clear Delete Group Errors',

  ActivateGroupRequest = '[Groups] Activate Group Request',
  ActivateGroupSuccess = '[Groups] Activate Group Success',
  ActivateGroupFailure = '[Groups] Activate Group Failure',
  ClearActivateGroupErrors = '[Groups] Clear Activate Group Errors',

  AddAdminsToTGGroupRequest = '[Groups] Add Admins ToTG Group Request',
  AddAdminsToTGGroupSuccess = '[Groups] Add Admins To TG Group Success',
  AddAdminsToTGGroupFailure = '[Groups] Add Admins To TG Group Failure',
  ClearAddAdminsToTGGroupErrors = '[Groups] Clear Add Admins To TG Group Errors',

  SendDeactivateGroupRequest = '[Groups] Send Deactivate Group Request',
  SendDeactivateGroupSuccess = '[Groups] Send Deactivate Group Success',
  SendDeactivateGroupFailure = '[Groups] Send Deactivate Group Failure',
  ClearDeactivateGroupErrors = '[Groups] Clear Deactivate Group Errors',

  SendTransfersStudentsToGroupRequest = '[Groups] Send Transfers Students To Group Request',
  SendTransfersStudentsToGroupSuccess = '[Groups] Send Transfers Students To Group Success',
  SendTransfersStudentsToGroupFailure = '[Groups] Send Transfers Students To Group Failure',
  ClearTransfersStudentsToGroupErrors = '[Groups] Clear Transfers Students To Group Errors',

  SendAddStudentsToGroupRequest = '[Groups] Send Students To Group Request',
  SendAddStudentsToGroupSuccess = '[Groups] Send Students To Group Success',
  SendAddStudentsToGroupFailure = '[Groups] Send Students To Group Failure',
  ClearAddStudentsToGroupErrors = '[Groups] Send Students To Group Errors',

  SendAddTeachersToGroupRequest = '[Groups] Send Teachers To Group Request',
  SendAddTeachersToGroupSuccess = '[Groups] Send Teachers To Group Success',
  SendAddTeachersToGroupFailure = '[Groups] Send Teachers To Group Failure',
  ClearAddTeachersToGroupErrors = '[Groups] Send Teachers To Group Errors',

  SendStudentDropoutFromGroupRequest = '[Groups] Send Student Dropout From Group Request',
  SendStudentDropoutFromGroupSuccess = '[Groups] Send Student Dropout From Group Success',
  SendStudentDropoutFromGroupFailure = '[Groups] Send Student Dropout From Group Failure',
  ClearStudentDropoutFromGroupErrors = '[Groups] Clear Student Dropout From Group Errors',

  SendActivateStudentToGroupRequest = '[Groups] Send Activate Student To Group Request',
  SendActivateStudentToGroupSuccess = '[Groups] Send Activate Student To Group Success',
  SendActivateStudentToGroupFailure = '[Groups] Send Activate Student To Group Failure',
  ClearActivateStudentToGroupErrors = '[Groups] Clear Activate Student To Group Errors',

  SetStudentOnlineRequest = '[Groups] Set Student Online Request',
  SetStudentOnlineSuccess = '[Groups] Set Student Online Success',
  SetStudentOnlineFailure = '[Groups] Set Student Online Failure',
  ClearSetStudentOnlineErrors = '[Groups] Clear Set Student Online Errors',

  DeleteTeacherRequest = '[Groups] Delete Teacher Request',
  DeleteTeacherSuccess = '[Groups] Delete Teacher Success',
  DeleteTeacherFailure = '[Groups] Delete Teacher Failure',
  ClearDeleteTeacherErrors = '[Groups] Clear Delete Teacher Errors',
  DeleteTeacherFromSelectedGroupsRequest = '[Groups] Delete Teacher From Selected Groups Request',
  DeleteTeacherFromSelectedGroupsSuccess = '[Groups] Delete Teacher From Selected Groups Success',
  DeleteTeacherFromSelectedGroupsFailure = '[Groups] Delete Teacher From Selected Groups Failure',
  ClearDeleteTeacherFromSelectedGroups = '[Groups] Clear Delete Teacher From Selected Groups',

  EditStudentAccessRequest = '[Groups] Edit Student Access Request',
  EditStudentAccessSuccess = '[Groups] Edit Student Access Success',
  EditStudentAccessFailure = '[Groups] Edit Student Access Failure',
  ClearEditStudentAccess = '[Groups] Clear Edit Student Access',

  TransferToESDPRequest = '[Groups] Transfer To ESDP Request',
  TransferToESDPSuccess = '[Groups] Transfer To ESDP Success',
  TransferToESDPFailure = '[Groups] Transfer To ESDP Failure',
  ClearTransferToESDP = '[Groups] Clear Transfer To ESDP',

  ReturnTeacherRequest = '[Groups] Return Teacher Request',
  ReturnTeacherSuccess = '[Groups] Return Teacher Success',
  ReturnTeacherFailure = '[Groups] Return Teacher Failure',
  ClearReturnTeacher = '[Groups] Clear Return Teacher',

  AddCheckingTeacherRequest = '[Groups] Add Checking Teacher Request',
  AddCheckingTeacherSuccess = '[Groups] Add Checking Teacher Success',
  AddCheckingTeacherFailure = '[Groups] Add Checking Teacher Failure',
  ClearAddCheckingTeacherErrors = '[Groups] Clear Add Checking Teacher Errors',

  DeleteCheckingTeacherRequest = '[Groups] Delete Checking Teacher Request',
  DeleteCheckingTeacherSuccess = '[Groups] Delete Checking Teacher Success',
  DeleteCheckingTeacherFailure = '[Groups] Delete Checking Teacher Failure',
  ClearDeleteCheckingTeacherErrors = '[Groups] Clear Delete Checking Teacher Errors',

  RefreshCheckingTeacherHomeworksRequest = '[Groups] Refresh Checking Teacher Homeworks Request',
  RefreshCheckingTeacherHomeworksSuccess = '[Groups] Refresh Checking Teacher Homeworks Success',
  RefreshCheckingTeacherHomeworksFailure = '[Groups] Refresh Checking Teacher Homeworks Failure',
  ClearRefreshCheckingTeacherHomeworksErrors = '[Groups] Clear Refresh Checking Teacher Homeworks Errors',

  StudentHappyPointAllowedRequest = '[Groups] Student Happy Point Allowed Request',
  StudentHappyPointAllowedSuccess = '[Groups] Student Happy Point Allowed Success',
  StudentHappyPointAllowedFailure = '[Groups] Student Happy Point Allowed Failure',
  ClearStudentHappyPointAllowed = '[Groups] Clear Student Happy Point Allowed',

  DeleteTeacherFromGroupRequest = '[Groups] Delete Teacher From Group Request',
  DeleteTeacherFromGroupSuccess = '[Groups] Delete Teacher From Group Success',
  DeleteTeacherFromGroupFailure = '[Groups] Delete Teacher From Group Failure',
  ClearDeleteTeacherFromGroup = '[Groups] Clear Delete Teacher From Group',

  ChangeAttentionESDPGroupTrue = '[Groups] Change Attention ESDP from Group True',
  ChangeAttentionESDPGroupFalse = '[Groups] Change Attention ESDP from Group True',
}

export class AddAdminsToTGGroupRequest implements Action {
  public readonly type = EGroupsChangesActions.AddAdminsToTGGroupRequest;

  constructor(
    public data: { group?: number; team?: number; users: number[] }
  ) {}
}

export class AddAdminsToTGGroupSuccess implements Action {
  public readonly type = EGroupsChangesActions.AddAdminsToTGGroupSuccess;
}

export class AddAdminsToTGGroupFailure implements Action {
  public readonly type = EGroupsChangesActions.AddAdminsToTGGroupFailure;

  constructor(public errors: IFormErrors) {}
}

export class ClearAddAdminsToTGGroupErrors implements Action {
  public readonly type = EGroupsChangesActions.ClearAddAdminsToTGGroupErrors;
}

export class SendCreateGroupRequest implements Action {
  public readonly type = EGroupsChangesActions.SendCreateGroupRequest;

  constructor(public data: IGroup) {}
}

export class SendCreateGroupSuccess implements Action {
  public readonly type = EGroupsChangesActions.SendCreateGroupSuccess;
}

export class SendCreateGroupFailure implements Action {
  public readonly type = EGroupsChangesActions.SendCreateGroupFailure;

  constructor(public errors: IGroupFormErrors) {}
}

export class ClearCreateGroupErrors implements Action {
  public readonly type = EGroupsChangesActions.ClearCreateGroupErrors;
}

export class SendUpdateGroupRequest implements Action {
  public readonly type = EGroupsChangesActions.SendUpdateGroupRequest;

  constructor(public id: number, public data: IGroup) {}
}

export class SendUpdateGroupSuccess implements Action {
  public readonly type = EGroupsChangesActions.SendUpdateGroupSuccess;
}

export class SendUpdateGroupFailure implements Action {
  public readonly type = EGroupsChangesActions.SendUpdateGroupFailure;

  constructor(public errors: IGroupFormErrors) {}
}

export class ClearUpdateGroupErrors implements Action {
  public readonly type = EGroupsChangesActions.ClearUpdateGroupErrors;
}

export class DeleteGroupRequest implements Action {
  public readonly type = EGroupsChangesActions.DeleteGroupRequest;

  constructor(public id: number, public title: string) {}
}

export class DeleteGroupSuccess implements Action {
  public readonly type = EGroupsChangesActions.DeleteGroupSuccess;
}

export class DeleteGroupFailure implements Action {
  public readonly type = EGroupsChangesActions.DeleteGroupFailure;

  constructor(public errors: IFormErrors) {}
}

export class ClearDeleteGroupErrors implements Action {
  public readonly type = EGroupsChangesActions.ClearDeleteGroupErrors;
}

export class SendDeactivateGroupRequest implements Action {
  public readonly type = EGroupsChangesActions.SendDeactivateGroupRequest;

  constructor(public id: number) {}
}

export class SendDeactivateGroupSuccess implements Action {
  public readonly type = EGroupsChangesActions.SendDeactivateGroupSuccess;
}

export class SendDeactivateGroupFailure implements Action {
  public readonly type = EGroupsChangesActions.SendDeactivateGroupFailure;

  constructor(public errors: IFormErrors) {}
}

export class ClearDeactivateGroupErrors implements Action {
  public readonly type = EGroupsChangesActions.ClearDeactivateGroupErrors;
}

export class ActivateGroupRequest implements Action {
  public readonly type = EGroupsChangesActions.ActivateGroupRequest;

  constructor(public id: number) {}
}

export class ActivateGroupSuccess implements Action {
  public readonly type = EGroupsChangesActions.ActivateGroupSuccess;
}

export class ActivateGroupFailure implements Action {
  public readonly type = EGroupsChangesActions.ActivateGroupFailure;

  constructor(public errors: IFormErrors) {}
}

export class ClearActivateGroupErrors implements Action {
  public readonly type = EGroupsChangesActions.ClearActivateGroupErrors;
}

export class SendTransfersStudentsToGroupRequest implements Action {
  public readonly type =
    EGroupsChangesActions.SendTransfersStudentsToGroupRequest;

  constructor(
    public id: number,
    public data: { students: number[]; group: number }
  ) {}
}

export class SendTransfersStudentsToGroupSuccess implements Action {
  public readonly type =
    EGroupsChangesActions.SendTransfersStudentsToGroupSuccess;
}

export class SendTransfersStudentsToGroupFailure implements Action {
  public readonly type =
    EGroupsChangesActions.SendTransfersStudentsToGroupFailure;

  constructor(public errors: IFormErrors) {}
}

export class ClearTransfersStudentsToGroupErrors implements Action {
  public readonly type =
    EGroupsChangesActions.ClearTransfersStudentsToGroupErrors;
}

export class SendAddStudentsToGroupRequest implements Action {
  public readonly type = EGroupsChangesActions.SendAddStudentsToGroupRequest;

  constructor(public id: number, public students: number[]) {}
}

export class SendAddStudentsToGroupSuccess implements Action {
  public readonly type = EGroupsChangesActions.SendAddStudentsToGroupSuccess;
}

export class SendAddStudentsToGroupFailure implements Action {
  public readonly type = EGroupsChangesActions.SendAddStudentsToGroupFailure;

  constructor(public errors: IFormErrors) {}
}

export class ClearAddStudentsToGroupErrors implements Action {
  public readonly type = EGroupsChangesActions.ClearAddStudentsToGroupErrors;
}

export class SendAddTeachersToGroupRequest implements Action {
  public readonly type = EGroupsChangesActions.SendAddTeachersToGroupRequest;

  constructor(public id: number, public teachers: number[]) {}
}

export class SendAddTeachersToGroupSuccess implements Action {
  public readonly type = EGroupsChangesActions.SendAddTeachersToGroupSuccess;
}

export class SendAddTeachersToGroupFailure implements Action {
  public readonly type = EGroupsChangesActions.SendAddTeachersToGroupFailure;

  constructor(public errors: IFormErrors) {}
}

export class ClearAddTeachersToGroupErrors implements Action {
  public readonly type = EGroupsChangesActions.ClearAddTeachersToGroupErrors;
}

export class SendStudentDropoutFromGroupRequest implements Action {
  public readonly type =
    EGroupsChangesActions.SendStudentDropoutFromGroupRequest;

  constructor(public id: number, public students: number[]) {}
}

export class SendStudentDropoutFromGroupSuccess implements Action {
  public readonly type =
    EGroupsChangesActions.SendStudentDropoutFromGroupSuccess;
}

export class SendStudentDropoutFromGroupFailure implements Action {
  public readonly type =
    EGroupsChangesActions.SendStudentDropoutFromGroupFailure;

  constructor(public errors: IFormErrors) {}
}

export class ClearStudentDropoutFromGroupErrors implements Action {
  public readonly type =
    EGroupsChangesActions.ClearStudentDropoutFromGroupErrors;
}

export class SendActivateStudentToGroupRequest implements Action {
  public readonly type =
    EGroupsChangesActions.SendActivateStudentToGroupRequest;

  constructor(public id: number, public students: number[]) {}
}

export class SendActivateStudentToGroupSuccess implements Action {
  public readonly type =
    EGroupsChangesActions.SendActivateStudentToGroupSuccess;
}

export class SendActivateStudentToGroupFailure implements Action {
  public readonly type =
    EGroupsChangesActions.SendActivateStudentToGroupFailure;

  constructor(public errors: IFormErrors) {}
}

export class ClearActivateStudentToGroupErrors implements Action {
  public readonly type =
    EGroupsChangesActions.ClearActivateStudentToGroupErrors;
}

export class SetStudentOnlineInGroupRequest implements Action {
  public readonly type = EGroupsChangesActions.SetStudentOnlineRequest;

  constructor(public groupId: number, public studentId: number) {}
}

export class SetStudentOnlineInGroupSuccess implements Action {
  public readonly type = EGroupsChangesActions.SetStudentOnlineSuccess;
}

export class SetStudentOnlineInGroupFailure implements Action {
  public readonly type = EGroupsChangesActions.SetStudentOnlineFailure;

  constructor(public errors: IFormErrors) {}
}

export class ClearSetStudentOnlineInGroupsErrors implements Action {
  public readonly type = EGroupsChangesActions.ClearSetStudentOnlineErrors;
}

export class DeleteTeacherFromGroupRequest implements Action {
  public readonly type = EGroupsChangesActions.DeleteTeacherRequest;

  constructor(public id: number, public teachers: number[]) {}
}

export class ClearDeleteTeacherFromSelectedGroups implements Action {
  public readonly type =
    EGroupsChangesActions.ClearDeleteTeacherFromSelectedGroups;
}

export class DeleteTeacherFromGroupSuccess implements Action {
  public readonly type = EGroupsChangesActions.DeleteTeacherSuccess;
}

export class DeleteTeacherFromGroupFailure implements Action {
  public readonly type = EGroupsChangesActions.DeleteTeacherFailure;

  constructor(public errors: IFormErrors) {}
}

export class ClearDeleteTeacherFromGroupErrors implements Action {
  public readonly type = EGroupsChangesActions.ClearDeleteTeacherErrors;
}

export class EditStudentAccessRequest implements Action {
  public readonly type = EGroupsChangesActions.EditStudentAccessRequest;

  constructor(
    public id: number,
    public data: { start_date: string; end_date: string; students: number[] }
  ) {}
}

export class EditStudentAccessSuccess implements Action {
  public readonly type = EGroupsChangesActions.EditStudentAccessSuccess;
}

export class EditStudentAccessFailure implements Action {
  public readonly type = EGroupsChangesActions.EditStudentAccessFailure;

  constructor(public errors: IFormErrors) {}
}

export class ClearEditStudentAccess implements Action {
  public readonly type = EGroupsChangesActions.ClearEditStudentAccess;
}

export class TransferToESDPRequest implements Action {
  public readonly type = EGroupsChangesActions.TransferToESDPRequest;

  constructor(
    public groupId: number,
    public courseId: number,
    public data: {
      lesson_days: string;
      period_start_date: string;
      is_esdp: boolean;
    }
  ) {}
}

export class TransferToESDPSuccess implements Action {
  public readonly type = EGroupsChangesActions.TransferToESDPSuccess;
}

export class TransferToESDPFailure implements Action {
  public readonly type = EGroupsChangesActions.TransferToESDPFailure;

  constructor(public errors: IFormErrors) {}
}

export class ClearTransferToESDP implements Action {
  public readonly type = EGroupsChangesActions.ClearTransferToESDP;
}

export class DeleteTeacherFromSelectedGroupsRequest implements Action {
  public readonly type =
    EGroupsChangesActions.DeleteTeacherFromSelectedGroupsRequest;

  constructor(public groups_id: number[], public teacher: number) {}
}

export class DeleteTeacherFromSelectedGroupsSuccess implements Action {
  public readonly type =
    EGroupsChangesActions.DeleteTeacherFromSelectedGroupsSuccess;
}

export class DeleteTeacherFromSelectedGroupsFailure implements Action {
  public readonly type =
    EGroupsChangesActions.DeleteTeacherFromSelectedGroupsFailure;

  constructor(public errors: IFormErrors) {}
}

export class ReturnTeacherRequest implements Action {
  public readonly type = EGroupsChangesActions.ReturnTeacherRequest;

  constructor(public group_id: number, public users: number[]) {}
}

export class ReturnTeacherSuccess implements Action {
  public readonly type = EGroupsChangesActions.ReturnTeacherSuccess;
}

export class ReturnTeacherFailure implements Action {
  public readonly type = EGroupsChangesActions.ReturnTeacherFailure;

  constructor(public errors: IFormErrors) {}
}

export class ClearReturnTeacher implements Action {
  public readonly type = EGroupsChangesActions.ClearReturnTeacher;
}

export class AddCheckingTeacherRequest implements Action {
  public readonly type = EGroupsChangesActions.AddCheckingTeacherRequest;

  constructor(public data: IAddCheckingTeacherData) {}
}

export class AddCheckingTeacherSuccess implements Action {
  public readonly type = EGroupsChangesActions.AddCheckingTeacherSuccess;
}

export class AddCheckingTeacherFailure implements Action {
  public readonly type = EGroupsChangesActions.AddCheckingTeacherFailure;

  constructor(public errors: IFormErrors) {}
}

export class ClearAddCheckingTeacherErrors implements Action {
  public readonly type = EGroupsChangesActions.ClearAddCheckingTeacherErrors;
}

export class DeleteCheckingTeacherRequest implements Action {
  public readonly type = EGroupsChangesActions.DeleteCheckingTeacherRequest;

  constructor(public teacher_id: number) {}
}

export class DeleteCheckingTeacherSuccess implements Action {
  public readonly type = EGroupsChangesActions.DeleteCheckingTeacherSuccess;
}

export class DeleteCheckingTeacherFailure implements Action {
  public readonly type = EGroupsChangesActions.DeleteCheckingTeacherFailure;

  constructor(public errors: IFormErrors) {}
}

export class ClearDeleteCheckingTeacherErrors implements Action {
  public readonly type = EGroupsChangesActions.ClearDeleteCheckingTeacherErrors;
}

export class RefreshCheckingTeacherHomeworksRequest implements Action {
  public readonly type =
    EGroupsChangesActions.RefreshCheckingTeacherHomeworksRequest;

  constructor(
    public group_id: number,
    public data: IRefreshCheckingTeacherHomeworks
  ) {}
}

export class RefreshCheckingTeacherHomeworksSuccess implements Action {
  public readonly type =
    EGroupsChangesActions.RefreshCheckingTeacherHomeworksSuccess;
}

export class RefreshCheckingTeacherHomeworksFailure implements Action {
  public readonly type =
    EGroupsChangesActions.RefreshCheckingTeacherHomeworksFailure;

  constructor(public errors: IFormErrors) {}
}

export class ClearRefreshCheckingTeacherHomeworksErrors implements Action {
  public readonly type =
    EGroupsChangesActions.ClearRefreshCheckingTeacherHomeworksErrors;
}

export class GroupsStudentHappyPointAllowedRequest implements Action {
  public readonly type = EGroupsChangesActions.StudentHappyPointAllowedRequest;

  constructor(public groupId: number, public data: IHappyPointMutation) {}
}

export class GroupsStudentHappyPointAllowedSuccess implements Action {
  public readonly type = EGroupsChangesActions.StudentHappyPointAllowedSuccess;
}

export class GroupsStudentHappyPointAllowedFailure implements Action {
  public readonly type = EGroupsChangesActions.StudentHappyPointAllowedFailure;
}

export class ClearGroupsStudentHappyPointAllowed implements Action {
  public readonly type = EGroupsChangesActions.ClearStudentHappyPointAllowed;
}

export class DeleteTeacherRequest implements Action {
  public readonly type = EGroupsChangesActions.DeleteTeacherFromGroupRequest;

  constructor(public groupId: number, public user: number) {}
}

export class DeleteTeacherSuccess implements Action {
  public readonly type = EGroupsChangesActions.DeleteTeacherFromGroupSuccess;
}

export class DeleteTeacherFailure implements Action {
  public readonly type = EGroupsChangesActions.DeleteTeacherFromGroupFailure;

  constructor(public errors: IFormErrors) {}
}

export class ClearDeleteTeacherErrors implements Action {
  public readonly type = EGroupsChangesActions.ClearDeleteTeacherErrors;
}

export class ChangeAttentionESDPGroupTrue implements Action {
  public readonly type = EGroupsChangesActions.ChangeAttentionESDPGroupTrue;
}

export class ChangeAttentionESDPGroupFalse implements Action {
  public readonly type = EGroupsChangesActions.ChangeAttentionESDPGroupFalse;
}

export type GroupsChangesActions =
  | SendCreateGroupRequest
  | SendCreateGroupSuccess
  | SendCreateGroupFailure
  | ClearCreateGroupErrors
  | SendUpdateGroupRequest
  | SendUpdateGroupSuccess
  | SendUpdateGroupFailure
  | ClearUpdateGroupErrors
  | DeleteGroupRequest
  | DeleteGroupSuccess
  | DeleteGroupFailure
  | ClearDeleteGroupErrors
  | SendDeactivateGroupRequest
  | SendDeactivateGroupSuccess
  | SendDeactivateGroupFailure
  | ClearDeactivateGroupErrors
  | ActivateGroupRequest
  | ActivateGroupSuccess
  | ActivateGroupFailure
  | ClearActivateGroupErrors
  | SendTransfersStudentsToGroupRequest
  | SendTransfersStudentsToGroupSuccess
  | SendTransfersStudentsToGroupFailure
  | ClearTransfersStudentsToGroupErrors
  | SendAddStudentsToGroupRequest
  | SendAddStudentsToGroupSuccess
  | SendAddStudentsToGroupFailure
  | ClearAddStudentsToGroupErrors
  | SendAddTeachersToGroupRequest
  | SendAddTeachersToGroupSuccess
  | SendAddTeachersToGroupFailure
  | ClearAddTeachersToGroupErrors
  | SendStudentDropoutFromGroupRequest
  | SendStudentDropoutFromGroupSuccess
  | SendStudentDropoutFromGroupFailure
  | ClearStudentDropoutFromGroupErrors
  | SendActivateStudentToGroupRequest
  | SendActivateStudentToGroupSuccess
  | SendActivateStudentToGroupFailure
  | ClearActivateStudentToGroupErrors
  | SetStudentOnlineInGroupRequest
  | SetStudentOnlineInGroupSuccess
  | SetStudentOnlineInGroupFailure
  | ClearSetStudentOnlineInGroupsErrors
  | DeleteTeacherFromGroupRequest
  | DeleteTeacherFromGroupSuccess
  | DeleteTeacherFromGroupFailure
  | ClearDeleteTeacherFromGroupErrors
  | EditStudentAccessRequest
  | EditStudentAccessSuccess
  | EditStudentAccessFailure
  | ClearEditStudentAccess
  | TransferToESDPRequest
  | TransferToESDPSuccess
  | TransferToESDPFailure
  | ClearTransferToESDP
  | DeleteTeacherFromSelectedGroupsRequest
  | DeleteTeacherFromSelectedGroupsSuccess
  | DeleteTeacherFromSelectedGroupsFailure
  | ClearDeleteTeacherFromSelectedGroups
  | ReturnTeacherRequest
  | ReturnTeacherSuccess
  | ReturnTeacherFailure
  | ClearReturnTeacher
  | AddCheckingTeacherRequest
  | AddCheckingTeacherSuccess
  | AddCheckingTeacherFailure
  | ClearAddCheckingTeacherErrors
  | DeleteCheckingTeacherRequest
  | DeleteCheckingTeacherSuccess
  | DeleteCheckingTeacherFailure
  | ClearDeleteCheckingTeacherErrors
  | RefreshCheckingTeacherHomeworksRequest
  | RefreshCheckingTeacherHomeworksSuccess
  | RefreshCheckingTeacherHomeworksFailure
  | ClearRefreshCheckingTeacherHomeworksErrors
  | GroupsStudentHappyPointAllowedRequest
  | GroupsStudentHappyPointAllowedSuccess
  | GroupsStudentHappyPointAllowedFailure
  | ClearGroupsStudentHappyPointAllowed
  | DeleteTeacherRequest
  | DeleteTeacherSuccess
  | DeleteTeacherFailure
  | AddAdminsToTGGroupRequest
  | AddAdminsToTGGroupSuccess
  | AddAdminsToTGGroupFailure
  | ClearAddAdminsToTGGroupErrors
  | ClearDeleteTeacherErrors
  | ChangeAttentionESDPGroupTrue
  | ChangeAttentionESDPGroupFalse;
